var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { BlogDirectoryContent } from "./BlogDirectoryContent";
import API_service from "@iscr/xAppLib/providers/API_service";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import { PAGE_IDS, BLOG_PAGE_SIZE } from "@iscr/contentful/constants";
import { Container, Loader } from "semantic-ui-react";
import { HomeMenu } from "@iscr/views/UIelems/v2/Header/HomeMenu";
import { useBlogContext } from "../context/BlogContext";
import { normalizeKeys } from "@iscr/contentful/functions";
import { useGetTagFromUrl } from "../useGetTagFromUrl";
import { useNavigate, useSearchParams } from "react-router";
import { SEOHeaders } from "@iscr/components/SEOHeaders";
const BlogDirectory = () => {
    useGetTagFromUrl();
    const { blogPosts = [], featuredPost, loading, page, onPageChange, totalPosts } = useBlogPosts();
    const preload = useMemo(() => { var _a, _b; return (((_a = window.___) === null || _a === void 0 ? void 0 : _a.loc) === location.pathname && ((_b = window.___) === null || _b === void 0 ? void 0 : _b.content)) || null; }, [page]);
    useEffect(() => {
        if (!loading && window.___)
            window.___.content = null;
    }, [loading]);
    if (loading) {
        if (preload) {
            return _jsx("div", { dangerouslySetInnerHTML: { __html: preload } });
        }
        return (_jsx(Container, { className: "relative flex-1", children: _jsx(Loader, { active: true, children: "Loading page..." }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(SEOHeaders, { title: "Health Hub - InstantScripts", path: window.location.pathname, metaDescription: undefined, index: true, follow: true }), _jsx(HomeMenu, {}), _jsx(BlogDirectoryContent, { blogPosts: blogPosts, featuredPost: featuredPost, page: page, onPageChange: onPageChange, totalPosts: totalPosts, pageSize: BLOG_PAGE_SIZE })] }));
};
const useBlogPosts = () => {
    var _a;
    const navigate = useNavigate();
    const { selectedTag } = useBlogContext();
    const [searchParams] = useSearchParams();
    const rawPage = Number(searchParams.get("page") || "1");
    const page = Number.isFinite(rawPage) ? Math.max(0, Math.floor(rawPage) - 1) : 0;
    const searchQuery = ((_a = searchParams.get("search")) === null || _a === void 0 ? void 0 : _a.trim()) || "";
    const { data: { blogPosts, featuredPost, totalPosts } = {}, loading } = useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield API_service.load_data("cms/getEntries", {
                content_type: PAGE_IDS.BLOG_POST,
                order: ["-fields.postDate"],
                pagination: {
                    limit: BLOG_PAGE_SIZE,
                    skip: page * BLOG_PAGE_SIZE,
                },
                content_tags: selectedTag && selectedTag !== "All" ? [normalizeKeys(selectedTag)] : undefined,
                filters: searchQuery ? [{ name: "query", value: searchQuery }] : undefined,
                preview: false,
            });
            if (response.status === "ok") {
                let blogPosts = response.entries.items;
                const featuredPost = blogPosts[0];
                // Remove the featured post from the blogPosts array
                blogPosts = blogPosts.filter(post => post !== featuredPost);
                const totalPosts = response.entries.total;
                return { blogPosts, featuredPost, totalPosts };
            }
            else {
                console.error("Failed to fetch blog posts:", response);
                return { blogPosts: [], featuredPost: null, totalPosts: 0 };
            }
        }
        catch (error) {
            console.error("Error fetching blog posts:", error);
            return { blogPosts: [], featuredPost: null, totalPosts: 0 };
        }
    }), [page, selectedTag, searchQuery]);
    const onPageChange = (newPage) => {
        const params = new URLSearchParams(searchParams);
        if (newPage <= 0)
            params.delete("page");
        else
            params.set("page", String(newPage + 1));
        navigate({ search: params.toString() });
    };
    return { blogPosts, featuredPost, loading, page, onPageChange, totalPosts };
};
export default BlogDirectory;
